'use strict';

var EMAIL_PRODUCT_TYPE = {
  MICROSOFT365: 'MICROSOFT365',
  PROFESSIONAL: 'PROFESSIONAL'
};

// All US, CA, GB, and AU markets.
var EXCLUSIVE_MICROSOFT365_MARKETS = ['en-US', 'es-US', 'en-CA', 'fr-CA', 'en-GB', 'en-AU'];

var PROFESSIONAL_EMAIL_MARKETS = ['ar-AE', 'el-GR', 'en-AE', 'en-HK', 'en-IN', 'en-MY', 'en-PH', 'en-PK', 'en-SG', 'en-ZA', 'es-AR', 'es-CL', 'es-CO', 'es-ES', 'es-MX', 'es-PE', 'es-VE', 'hi-IN', 'id-ID', 'it-IT', 'ja-JP', 'ko-KR', 'pl-PL', 'pt-BR', 'pt-PT', 'ru-RU', 'th-TH', 'tr-TR', 'uk-UA', 'vi-VN', 'zh-HK', 'zh-SG', 'zh-TW'];

var getIsOptedInToMicrosoft365 = function getIsOptedInToMicrosoft365(productGroups) {
  return !!productGroups && !!productGroups.find(function (group) {
    return group.pl_productGroupID === '100';
  });
};

// See `./README.md` for a visualization of all the scenarios.
var getAllowedEmailProductTypes = function getAllowedEmailProductTypes(_ref) {
  var privateLabelId = _ref.privateLabelId,
      _ref$privateLabelIdTh = _ref.privateLabelIdThreshold,
      privateLabelIdThreshold = _ref$privateLabelIdTh === undefined ? 0 : _ref$privateLabelIdTh,
      isOptedInToMicrosoft365 = _ref.isOptedInToMicrosoft365,
      market = _ref.market;

  // eslint-disable-next-line no-undef
  var allowedTypes = new Set();

  if (isOptedInToMicrosoft365) {
    allowedTypes.add(EMAIL_PRODUCT_TYPE.MICROSOFT365);
  }

  if (PROFESSIONAL_EMAIL_MARKETS.includes(market) && (!isOptedInToMicrosoft365 || !EXCLUSIVE_MICROSOFT365_MARKETS.includes(market))) {
    allowedTypes.add(EMAIL_PRODUCT_TYPE.PROFESSIONAL);
  }

  if (!isOptedInToMicrosoft365 || privateLabelId < privateLabelIdThreshold && !EXCLUSIVE_MICROSOFT365_MARKETS.includes(market)) {
    allowedTypes.add(EMAIL_PRODUCT_TYPE.PROFESSIONAL);
  }

  return Array.from(allowedTypes);
};

module.exports = {
  EMAIL_PRODUCT_TYPE: EMAIL_PRODUCT_TYPE,
  EXCLUSIVE_MICROSOFT365_MARKETS: EXCLUSIVE_MICROSOFT365_MARKETS,
  PROFESSIONAL_EMAIL_MARKETS: PROFESSIONAL_EMAIL_MARKETS,
  getIsOptedInToMicrosoft365: getIsOptedInToMicrosoft365,
  getAllowedEmailProductTypes: getAllowedEmailProductTypes
};